<script>
import axios from "axios";
import {mapGetters} from "vuex";
import html2pdf from "html2pdf.js";

export default {
  name: 'PrintServiceRecord',
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    hoursTimeTotal() {
      if (!this.serviceRecord || !this.serviceRecord.customer_services) return 0;
      return this.serviceRecord.customer_services.data
        .filter(t => !t.is_fixed_value)
        .reduce((acc, t) => acc + t.time_spent, 0);
    },
    hoursAmountSubtotal() {
      if (!this.serviceRecord || !this.serviceRecord.customer_services) return 0;
      return this.serviceRecord.customer_services.data
        .filter(t => !t.is_fixed_value)
        .reduce((acc, t) => acc + t.amount_time_spent, 0);
    },
    fixedAmountSubtotal() {
      if (!this.serviceRecord || !this.serviceRecord.customer_services) return 0;
      return this.serviceRecord.customer_services.data
        .filter(t => t.is_fixed_value)
        .reduce((acc, t) => {
          let val = t.fixed_value ? parseFloat(t.fixed_value) : t.amount_time_spent;
          return acc + val;
        }, 0);
    }
  },
  data () {
    return {
      isLoading: true,
      serviceRecord: false,
      subsidiary: false,
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.loadSubsidiary();
      this.loadData();
    },
    loadSubsidiary () {
      axios
        .get(`/api/subsidiaries/${this.user.subsidiary_id}`)
        .then(({ data }) => this.subsidiary = data.data)
    },
    loadData () {
      this.isLoading = true;

      axios
        .get(`/api/service-record/${this.$route.params.id}`)
        .then(({ data }) => this.serviceRecord = data.data)
        .catch(() => {
          this.$swal({
            title: 'Ops...',
            text: 'Ficha não encontrada',
            icon: 'error',
          })
        })
        .then(() => this.isLoading = false)
    },
    formatDateBrToView(originalDate) {
      const data = new Date(originalDate);
      let timezoneOffset = -180;
      data.setMinutes(data.getMinutes() - timezoneOffset);
      return data.toLocaleDateString("pt-BR");
    },
    secondsToDate(seconds) {
      if (isNaN(seconds)) {
        return '00:00'
      }
      let hours = Math.floor(seconds / 3600)
      seconds %= 3600
      let minutes = Math.floor(seconds / 60)
      seconds = seconds % 60

      return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
    },
    totalAmountTicket (amountExpense, amountTimeSpent) {
      return amountExpense + amountTimeSpent;
    },
    print () {
      html2pdf(document.getElementById('element-to-convert'), {
        margin: 3,
        filename: `Ficha-${this.serviceRecord.id}-${this.serviceRecord.customer_name}`,
      });
    }
  }
}
</script>

<template>
  <div class="mb-3 container-sm" style="max-width: 220mm">
    <div v-if="isLoading" class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else class="card" id="element-to-convert">
      <div class="card-header text-center text-uppercase">
        {{ subsidiary.name }}
      </div>
      <div class="card-body">
        <div class="card-title text-uppercase text-center">
          relatório de serviços
        </div>
        <span class="d-flex">
          <span><b>Cliente:</b> {{serviceRecord.customer_name}}</span>
          <span class="ms-auto"><b>Ficha N° </b> {{serviceRecord.id}}</span>
        </span>


        <hr />
        <b>Serviços executados</b>
        <div class="card my-2" v-for="ticket in serviceRecord.customer_services.data" :key="ticket.id">
          <div class="card-body">
            <div class="d-flex my-2">
              <div>
                <b>Ticket n°:</b> <span class="ms-2">{{ticket.id}}</span>
                <span v-if="ticket.is_fixed_value" class="badge bg-secondary ms-2">VALOR FIXO</span>
              </div>
              <div class="ms-auto me-5">
                <b>Consultor:</b> <span class="ms-2">{{ticket.user_name}}</span>
              </div>
            </div>
            <p>{{ticket.note}}</p>

            <span><b>Atividades:</b></span>
            <table class="table font-small" v-if="ticket.tasks_made.data.length > 0">
              <thead v-if="ticket.is_fixed_value">
              <tr>
                <th>Data</th>
                <th>Total (R$)</th>
                <th>Observaçoes</th>
              </tr>
              </thead>
              <thead v-else>
              <tr>
                <th>Data</th>
                <th>Inicio</th>
                <th>Fim</th>
                <th>Apontado</th>
                <th>Atividade</th>
                <th>Valor(R$/h)</th>
                <th>Total (R$)</th>
                <th>Observaçoes</th>
              </tr>
              </thead>
              <tbody v-if="ticket.is_fixed_value">
                <tr v-for="taskMade in ticket.tasks_made.data" :key="taskMade.id">
                  <td>{{formatDateBrToView(taskMade.made_at)}}</td>
                  <td class="tasks-td-medium"><money class="hide-input" v-model="taskMade.amount" disabled/></td>
                  <td class="overflow-auto">{{taskMade.note}}</td>
                </tr>
              </tbody>
              <tbody v-else>
              <tr v-for="taskMade in ticket.tasks_made.data" :key="taskMade.id">
                <td>{{formatDateBrToView(taskMade.made_at)}}</td>
                <td class="tasks-td-small">
                  <input
                    v-mask="'##:##'"
                    class="hide-input"
                    :value="taskMade.started_at"
                    disabled
                  >
                </td>
                <td class="tasks-td-small">
                  <input
                    v-mask="'##:##'"
                    class="hide-input"
                    :value="taskMade.finished_at"
                    disabled
                  >
                </td>
                <td class="tasks-td-small">{{secondsToDate(taskMade.time_spent)}}</td>
                <td>{{taskMade.task.data.name}}</td>
                <td class="tasks-td-small"><money class="hide-input" v-model="taskMade.task_type.data.amount" disabled/></td>
                <td class="tasks-td-medium"><money class="hide-input" v-model="taskMade.amount" disabled/></td>
                <td class="overflow-auto">{{taskMade.note}}</td>
              </tr>
              </tbody>
            </table>
            <p v-else class="text-muted italic small">Ticket de projeto com valor fixo acordado.</p>
            <h6><b>Total das atividade:</b></h6>
            <div class="d-flex">
              <span><b>Apontado:</b> {{secondsToDate(ticket.time_spent)}} </span>
              <span class="ms-5"><b>Total:</b><money class="hide-input" v-model="ticket.amount_time_spent" disabled/></span>
            </div>
            <hr />

            <span class="mt-2"><b>Despesas:</b></span>
            <table class="table font-small">
              <thead>
              <tr>
                <th>Data</th>
                <th>NF/Ticket</th>
                <th>Tipo</th>
                <th>Valor</th>
                <th>Observação</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="expense in ticket.incurred_expenses.data" :key="expense.id">
                <td>{{formatDateBrToView(expense.date)}}</td>
                <td>{{expense.ticket}}</td>
                <td>{{expense.expense_name}}</td>
                <td><money class="hide-input" v-model="expense.amount" disabled/></td>
                <td class="overflow-auto">{{expense.note}}</td>
              </tr>
              </tbody>
            </table>
            <h6><b>Total das despesas:</b> <money class="hide-input" v-model="ticket.amount_expense" disabled/></h6>
          </div>
          <div class="card-footer">
            <h6>
              <b class="me-2">Total Ticket n° {{ticket.id}}:</b>
              <money class="hide-input" :value="totalAmountTicket(ticket.amount_expense,  ticket.amount_time_spent)" disabled/>
            </h6>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <h6 class="text-uppercase text-center">Resumo Financeiro</h6>

        <div class="mt-4">
          <table class="table table-sm table-bordered align-middle font-small text-center" style="width: 100%; table-layout: fixed;">
            <thead class="table-light">
            <tr>
              <th colspan="2" style="width: 30%">Atividades por Hora</th>
              <th style="width: 20%">Projetos (Fixo)</th>
              <th colspan="2" style="width: 30%">Outros Lançamentos</th>
              <th style="width: 20%">Total Geral</th>
            </tr>
            <tr>
              <th style="width: 15%">Tempo Total</th>
              <th style="width: 15%">Valor Horas</th>
              <th style="width: 20%">Valor Projetos</th>
              <th style="width: 15%">Despesas(+)</th>
              <th style="width: 15%">Descontos(-)</th>
              <th style="width: 20%">A Pagar</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{secondsToDate(hoursTimeTotal)}}</td>
              <td class="text-truncate"><money class="hide-input" :value="hoursAmountSubtotal" disabled/></td>
              <td class="text-truncate"><money class="hide-input" :value="fixedAmountSubtotal" disabled/></td>
              <td class="text-truncate"><money class="hide-input" v-model="serviceRecord.amount_expenses" disabled/></td>
              <td class="text-truncate"><money class="hide-input" v-model="serviceRecord.amount_discount" disabled/></td>
              <td class="text-truncate"><strong><money class="hide-input" v-model="serviceRecord.amount" disabled/></strong></td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-3">
          <p class="mb-1"><b>Observações:</b></p>
          <p class="text-muted">{{serviceRecord.note || 'Nenhuma observação informada.'}}</p>
        </div>
        <br />

        <div class="container my-5">
          <div class="row text-center gap-5">
            <div class="col border-top">{{serviceRecord.customer_name}}</div>
            <div class="col border-top">{{subsidiary.name}}</div>
          </div>
        </div>

      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary mt-3 justify-content-end" @click="print">Gerar PDF</button>
    </div>
  </div>
</template>

<style lang="sass">
  .font-small
    font-size: 0.8rem

  .tasks-td-small
    min-width: 50px
    max-width: 50px
    white-space: nowrap

  .tasks-td-medium
    min-width: 70px
    max-width: 70px
    white-space: nowrap
</style>
